import React, { useState, useEffect } from "react";
import { db } from "../../firebase";
import {
  collection,
  doc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import AOS from "aos";
import "aos/dist/aos.css";

const SignUpForm = () => {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    paymentStatus: "Not Paid",
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 700, once: true });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handlePayPalClick = () => {
    window.open(
      "https://www.paypal.com/cgi-bin/webscr?cmd=_xclick&business=admin@recoverycapitalstl.org&item_name=Emotional+Sobriety+Workshop+2025&amount=40.00&currency_code=USD",
      "_blank",
      "noopener,noreferrer,width=600,height=700"
    );
    setForm((prev) => ({ ...prev, paymentStatus: "Paid" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const docRef = doc(collection(db, "signups"), form.email);
      await setDoc(docRef, {
        ...form,
        timestamp: serverTimestamp(),
      });
      setSubmitted(true);
      setForm({
        fullName: "",
        email: "",
        phone: "",
        paymentStatus: "Not Paid",
      });
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Submission failed: " + error.message);
    }
    setLoading(false);
  };

  if (submitted) {
    return (
      <div
        className="text-center text-green-600 font-semibold mt-10 text-lg"
        data-aos="zoom-in"
      >
        ✅ Registration submitted successfully!
      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-xl mx-auto space-y-5 px-5 py-8 bg-white rounded-2xl shadow-xl mt-6"
      data-aos="fade-up"
    >
      <h3
        className="text-2xl sm:text-3xl font-bold text-center mb-6 text-blue-800"
        data-aos="fade-down"
      >
        Emotional Sobriety Workshop 23-24 August 2025
      </h3>

      <input
        name="fullName"
        type="text"
        value={form.fullName}
        onChange={handleChange}
        required
        placeholder="Full Name"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
        data-aos="fade-right"
      />

      <input
        name="email"
        type="email"
        value={form.email}
        onChange={handleChange}
        required
        placeholder="Email Address"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
        data-aos="fade-left"
      />

      <input
        name="phone"
        type="tel"
        value={form.phone}
        onChange={handleChange}
        required
        placeholder="Phone Number"
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
        data-aos="fade-right"
      />

      <select
        name="paymentStatus"
        value={form.paymentStatus}
        onChange={handleChange}
        required
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 focus:outline-none transition"
        data-aos="fade-left"
      >
        <option value="Paid">Paid (via PayPal)</option>
        <option value="Not Paid">Not Paid</option>
      </select>

      <button
        type="button"
        onClick={handlePayPalClick}
        className="w-full bg-green-600 text-white py-3 rounded-lg font-semibold hover:bg-green-700 transition"
        data-aos="zoom-in"
      >
        💳 Pay $40 with PayPal
      </button>

      <button
        type="submit"
        disabled={loading}
        className={`w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition ${
          loading ? "opacity-70 cursor-not-allowed" : ""
        }`}
        data-aos="fade-up"
      >
        {loading ? "Submitting..." : "Submit Registration"}
      </button>
    </form>
  );
};

export default SignUpForm;